import React, { useState } from "react";
import { Fieldset, Field, Label } from "../../design/fieldset";
import { Input } from "../../design/input";
import { Button } from "../../design/button";
import { MonthlyExpenseInfo } from "../../models/MonthlyExpenseInfo";
import { ParticipantService } from "../../services/ParticipantService";
import { monthlyExpenseFields } from "../../constants/monthlyExpenseFields";

interface Props {
  participantId: string;
  value?: MonthlyExpenseInfo;
  onFormSubmitted?: () => void;
}

const MonthlyExpenseForm: React.FC<Props> = ({
  participantId,
  value,
  onFormSubmitted,
}) => {
  const [formState, setFormState] = useState<MonthlyExpenseInfo>(value ?? {});
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSaving(true);
    await ParticipantService.updateMonthlyExpenses(participantId, formState);
    onFormSubmitted?.();
  };

  return (
    <form onSubmit={handleSubmit}>
      <Fieldset className="space-y-4" disabled={isSaving}>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-4">
          {monthlyExpenseFields.map(({ name, label }) => (
            <Field key={name}>
              <Label htmlFor={name}>{label}</Label>
              <Input
                id={name}
                type="number"
                value={(formState as any)[name] ?? ""}
                onChange={(e) =>
                  setFormState({ ...formState, [name]: Number(e.target.value) })
                }
                disabled={isSaving}
              />
            </Field>
          ))}
        </div>

        {/* Submit Button */}
        <div className="flex justify-end pt-4">
          <Button type="submit" disabled={isSaving}>
            {isSaving ? "Saving..." : "Save Monthly Expenses"}
          </Button>
        </div>
      </Fieldset>
    </form>
  );
};

export default MonthlyExpenseForm;
